import {Component, Inject, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';

@Component({
  selector: 'app-edit-other-carac',
  templateUrl: './edit-other-carac.component.html',
  styleUrls: ['./edit-other-carac.component.scss']
})
export class EditOtherCaracComponent {

    favorite: Favorite;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public adService: AdService,
        public dialogRef: MatDialogRef<EditOtherCaracComponent>) {
        this.favorite = Object.assign({}, data.favorite);
        console.log(this.favorite.lot_copro)
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.favorite = this.adService.updateValues(this.favorite);
        this.dialogRef.close(this.favorite);
    }

}
